import { render, staticRenderFns } from "./ProjectPerformance.vue?vue&type=template&id=f67f3492&scoped=true&"
import script from "./ProjectPerformance.vue?vue&type=script&lang=js&"
export * from "./ProjectPerformance.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPerformance.vue?vue&type=style&index=0&id=f67f3492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67f3492",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f67f3492')) {
      api.createRecord('f67f3492', component.options)
    } else {
      api.reload('f67f3492', component.options)
    }
    module.hot.accept("./ProjectPerformance.vue?vue&type=template&id=f67f3492&scoped=true&", function () {
      api.rerender('f67f3492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/companies/ProjectPerformance.vue"
export default component.exports